module.exports = __webpack_public_path__ + "img/logo-vim.4d4c6cf6.svg";